export default {
  // 对话框标题
  dialogTitle: "同时段同IP时间配置",

  // 时间范围说明
  timeRangeDescription:
    "时间范围说明：[1天内]自然日，[3天内] 往前3天和往后3天，[1周内] 取年月日往前7天和往后7天，[1月内] 取年月日往前30天和往后30天，[3月内] 取年月日往前90天和往后90天，[半年内]取年月日往前180天和往后180天，[不限] 显示所有的同IP用户。",

  // 时间选项
  oneDay: "1天内",
  threeDays: "3天内",
  oneWeek: "1周内",
  oneMonth: "1月内",
  threeMonths: "3月内",
  halfYear: "半年内",
  noLimit: "不限",

  // 按钮
  cancel: "取消",
  confirm: "确认",

  // 消息提示
  configSuccess: "配置成功",
};
